// removed by extract-text-webpack-plugin
module.exports = {"content":"calendar__content-iTPbt","monthName":"calendar__monthName-2n4UZ","weekTitleText":"calendar__weekTitleText-CVI2u","table":"calendar__table-3-MVD","item":"calendar__item-3kGio","_notInPeriod":"calendar___notInPeriod-3ubBX","itemText":"calendar__itemText-ROiDf","year":"calendar__year-17tDE","_isDisabled":"calendar___isDisabled-2oUEe","month":"calendar__month-3RpLQ","_isInRange":"calendar___isInRange-2iUc2","_isBoundOfRange":"calendar___isBoundOfRange--Lbr5"};


//////////////////
// WEBPACK FOOTER
// ./~/account-ui/calendar/calendar.css
// module id = 855
// module chunks = 0